import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { ErrorResponseWithIdI } from 'src/app/core/models/error-response-with-id.interface';
import { TypesService } from 'src/app/core/services/api/types/types.service';
import { DictionaryI } from 'src/app/dictionaries/models/dictionary.interface';
import {
  CleanClientAssignmentTypesState,
  ClientAssignmentTypesActionTypes,
  LoadedClientAssignmentTypesFail,
  LoadedClientAssignmentTypesSuccess,
} from 'src/app/dictionaries/store/actions/client-assignment-types.action';

@Injectable()
export class ClientAssignmentTypesEffects {
  constructor(private actions$: Actions, private typesService: TypesService) {}

  public loadClientAssignmentTypes$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ClientAssignmentTypesActionTypes.LoadClientAssignmentTypes),
      switchMap(() =>
        this.typesService.getClientAssignmentTypes().pipe(
          map(
            (ClientAssignmentTypes: DictionaryI[]) =>
              new LoadedClientAssignmentTypesSuccess(ClientAssignmentTypes)
          ),
          catchError((error: ErrorResponseWithIdI) =>
            of(new LoadedClientAssignmentTypesFail(error))
          )
        )
      )
    )
  );

  public handleLoadedClientAssignmentTypesFail$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ClientAssignmentTypesActionTypes.LoadedClientAssignmentTypesFail),
      map(() => new CleanClientAssignmentTypesState())
    )
  );
}
